var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/index.js';
import { CallPatientStatus } from '../enums/call-patient.enum.js';
/**
 * Response DTO for CallPatient queries.
 * Carries the runtime state of a patient in a video call. Participant
 * acknowledgement status and the magic-link invite token live on
 * `AppointmentParticipantResponseDto` (populated from the linked Appointment).
 */
export class CallPatientResponseDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    patientId;
    callId;
    patient;
    /**
     * The parent call - populated when needed for certain operations.
     * Not always present, depends on the query context.
     */
    call;
    hasConnected;
    isAllowedEntry;
    /**
     * Transient field — the participant's acknowledgement lives on
     * `AppointmentParticipant.status` since the 2026-04 refactor. Populated
     * by the call response mapper from the linked appointment participant so
     * consumers that still render per-patient status keep working.
     */
    status;
    inviteToken;
}
__decorate([
    IsString(),
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallPatientResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallPatientResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], CallPatientResponseDto.prototype, "deletedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", String)
], CallPatientResponseDto.prototype, "patientId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], CallPatientResponseDto.prototype, "callId", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT] }),
    __metadata("design:type", Object)
], CallPatientResponseDto.prototype, "patient", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], CallPatientResponseDto.prototype, "call", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallPatientResponseDto.prototype, "hasConnected", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], CallPatientResponseDto.prototype, "isAllowedEntry", void 0);
__decorate([
    IsEnum(CallPatientStatus),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallPatientResponseDto.prototype, "status", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], CallPatientResponseDto.prototype, "inviteToken", void 0);
//# sourceMappingURL=call-patient.response.dto.js.map